// Core
import React, { useEffect, useState } from 'react';

// Icons
import { MdDoubleArrow, MdToken } from 'react-icons/md';
import {
  BiSolidRightArrow,
  BiSolidLeftArrow,
  BiSolidSprayCan,
} from 'react-icons/bi';
import { FaLock, FaCar } from 'react-icons/fa';
import { FaArrowsLeftRight } from 'react-icons/fa6';

// Chakra
import {
  Box,
  Button,
  Flex,
  Grid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text,
  useDisclosure,
} from '@chakra-ui/react';

// Components
import AttentionSaleModal from '../../../components/Attentions/AttentionSale';

const GarageModal = ({
  isOpen,
  onOpen,
  onClose,

  tokens,
  setTokens,

  cars,
  activeCar,
  setActiveCar,

  colors,
  activeColors,
  setActiveColors,

  pedals,
  activePedals,
  setActivePedals,

  pedalsIsAuto,
  setPedalsIsAuto,

  setViewMode,

  category,
  setCategory,
}) => {
  const [currentIndexCar, setCurrentIndexCar] =
    useState(parseInt(activeCar, 10));

  const [currentIndexPedals, setCurrentIndexPedals] =
    useState(parseInt(activePedals, 10));

  const [currentIndexColors, setCurrentIndexColors] =
    useState(parseInt(activeColors, 10));

  const {
    isOpen: AttentionSaleIsOpen,
    onOpen: AttentionSaleOnOpen,
    onClose: AttentionSaleOnClose,
  } = useDisclosure();

  const [carDefIndex] = useState(0);
  const [pedalDefIndex] = useState(0);
  const [colorDefIndex] = useState(0);

  const handleNextCar = () => {
    const next =
      parseInt(activeCar, 10) + 1 === cars.length
        ? 0
        : parseInt(activeCar, 10) + 1;

    setCurrentIndexCar(next);
    setActiveCar(next);
  };

  const handlePrevCar = () => {
    const prev =
      parseInt(activeCar, 10) - 1 < 0
        ? 0
        : parseInt(activeCar, 10) - 1;

    setCurrentIndexCar(prev);
    setActiveCar(prev);
  };

  const handleNextPedals = () => {
    const next =
      parseInt(activePedals, 10) + 1 === pedals.length
        ? 0
        : parseInt(activePedals, 10) + 1;

    setCurrentIndexPedals(next);
    setActivePedals(next);
  };

  const handlePrevPedals = () => {
    const prev =
      parseInt(activePedals, 10) - 1 < 0
        ? 0
        : parseInt(activePedals, 10) - 1;

    setCurrentIndexPedals(prev);
    setActivePedals(prev);
  };

  const handleSales = () => {
    if (
      cars[activeCar]?.price > 0 &&
      localStorage.getItem(`myCar${activeCar}`) !== 'true'
    ) {
      setActiveCar(carDefIndex);
      setCurrentIndexCar(carDefIndex);
    }

    if (
      pedals[activePedals]?.price > 0 &&
      localStorage.getItem(`myPedal${activePedals}`) !== 'true'
    ) {
      setActivePedals(pedalDefIndex);
      setCurrentIndexPedals(pedalDefIndex);
    }

    if (
      colors[activeColors]?.price > 0 &&
      localStorage.getItem(`myColor${activeColors}`) !== 'true'
    ) {
      setActiveColors(colorDefIndex);
      setCurrentIndexColors(colorDefIndex);
    }

    onClose();
  };

  const handleBuy = (type) => {
    if (
      type === 'car' &&
      parseInt(cars[currentIndexCar]?.price, 10) <=
        parseInt(tokens, 10)
    ) {
      localStorage.setItem(
        `myCar${currentIndexCar}`,
        'true'
      );

      const newTokens =
        parseInt(tokens, 10) -
        parseInt(cars[currentIndexCar].price, 10);

      setTokens(newTokens);
      localStorage.setItem(
        'tokens',
        String(newTokens)
      );
    }

    if (
      type === 'pedal' &&
      parseInt(pedals[currentIndexPedals]?.price, 10) <=
        parseInt(tokens, 10)
    ) {
      localStorage.setItem(
        `myPedal${currentIndexPedals}`,
        'true'
      );

      const newTokens =
        parseInt(tokens, 10) -
        parseInt(
          pedals[currentIndexPedals].price,
          10
        );

      setTokens(newTokens);
      localStorage.setItem(
        'tokens',
        String(newTokens)
      );
    }

    if (
      type === 'color' &&
      parseInt(colors[currentIndexColors]?.price, 10) <=
        parseInt(tokens, 10)
    ) {
      localStorage.setItem(
        `myColor${currentIndexColors}`,
        'true'
      );

      const newTokens =
        parseInt(tokens, 10) -
        parseInt(
          colors[currentIndexColors].price,
          10
        );

      setTokens(newTokens);
      localStorage.setItem(
        'tokens',
        String(newTokens)
      );
    }

    AttentionSaleOnClose();
  };

  useEffect(() => {
    const applyModalStyles = () => {
      const modalContainer = document.querySelector(
        '.chakra-modal__content-container'
      );

      if (modalContainer) {
        modalContainer.style.background =
          isOpen
            ? 'transparent'
            : 'transparent';
      }
    };

    if (isOpen) {
      setTimeout(applyModalStyles, 0);
      setViewMode(true);
    } else {
      applyModalStyles();
      setViewMode(false);
    }
  }, [isOpen, setViewMode]);

  const currentCar = cars[currentIndexCar];
  const currentPedal = pedals[currentIndexPedals];
  const currentColor = colors[currentIndexColors];

  const isCarLocked =
    currentCar?.price > 0 &&
    localStorage.getItem(
      `myCar${currentIndexCar}`
    ) !== 'true';

  const isPedalLocked =
    currentPedal?.price > 0 &&
    localStorage.getItem(
      `myPedal${currentIndexPedals}`
    ) !== 'true';

  const isColorLocked =
    currentColor?.price > 0 &&
    localStorage.getItem(
      `myColor${currentIndexColors}`
    ) !== 'true';

  const tabs = [
    {
      id: 0,
      title: 'Cars',
      icon: FaCar,
      color: '#C344FF',
    },
    {
      id: 1,
      title: 'Colors',
      icon: BiSolidSprayCan,
      color: '#39F56B',
    },
    {
      id: 2,
      title: 'Controls',
      icon: FaArrowsLeftRight,
      color: '#43F7FF',
    },
  ];

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={() => {
          handleSales();
          setCategory(0);
        }}
      >
        <ModalOverlay />

        <ModalContent
          className="modal__simple modal__purple"
          maxW={{ sm: '100%' }}
          mb="160px"
          overflow="hidden"
          position="relative"
        >
          <ModalCloseButton zIndex="20" />

          {/* Glow */}
          <Box
            position="absolute"
            top="-90px"
            left="-80px"
            w="220px"
            h="220px"
            bg="rgba(195,68,255,0.08)"
            filter="blur(70px)"
            pointerEvents="none"
          />

          <Box
            position="absolute"
            top="-80px"
            right="-70px"
            w="200px"
            h="200px"
            bg="rgba(67,247,255,0.07)"
            filter="blur(70px)"
            pointerEvents="none"
          />

          {/* Header */}
          <ModalHeader
            px="20px"
            pt="20px"
            pb="14px"
            position="relative"
            bg="rgba(0,0,0,0.16)"
            borderBottom="1px solid rgba(255,255,255,0.04)"
          >
            <Text
              fontSize="21px"
              fontWeight="900"
              letterSpacing="0.4px"
              color="rgba(255,255,255,0.82)"
            >
              Garage
            </Text>

            <Flex
              align="center"
              gap="7px"
              mt="4px"
            >
              <Box
                w="6px"
                h="6px"
                borderRadius="50%"
                bg="#C344FF"
                opacity="0.8"
                boxShadow="0 0 7px #C344FF"
              />

              <Text
                fontSize="11px"
                color="rgba(255,255,255,0.38)"
                fontWeight="600"
                textTransform="uppercase"
                letterSpacing="0.8px"
              >
                Customize your ride
              </Text>
            </Flex>
          </ModalHeader>

          <ModalBody
            px="14px"
            pt="14px"
            pb="18px"
            overflowY="auto"
            css={{
              '&::-webkit-scrollbar': {
                width: '4px',
              },
              '&::-webkit-scrollbar-thumb': {
                background:
                  'rgba(195,68,255,0.25)',
                borderRadius: '10px',
              },
            }}
          >
            {/* Tabs */}
            <Grid
              templateColumns="repeat(3, 1fr)"
              gap="7px"
              mb="16px"
              mt="24px"
            >
              {tabs.map((tab) => {
                const Icon = tab.icon;
                const active =
                  category === tab.id;

                return (
                  <Button
                    key={tab.id}
                    onClick={() =>
                      setCategory(tab.id)
                    }
                    h="54px"
                    px="6px"
                    borderRadius="14px"
                    variant="ghost"
                    bg={
                      active
                        ? `${tab.color}15`
                        : 'rgba(255,255,255,0.025)'
                    }
                    border={
                      active
                        ? `1px solid ${tab.color}55`
                        : '1px solid rgba(255,255,255,0.055)'
                    }
                    boxShadow={
                      active
                        ? `0 0 16px ${tab.color}18`
                        : 'none'
                    }
                    _hover={{
                      bg: `${tab.color}12`,
                    }}
                  >
                    <Flex
                      direction="column"
                      align="center"
                      gap="3px"
                    >
                      <Icon
                        size={17}
                        color={
                          active
                            ? tab.color
                            : '#6E7480'
                        }
                      />

                      <Text
                        fontSize="9px"
                        fontWeight="900"
                        color={
                          active
                            ? '#F5F8FB'
                            : 'rgba(255,255,255,0.35)'
                        }
                        textTransform="uppercase"
                        letterSpacing="0.5px"
                      >
                        {tab.title}
                      </Text>
                    </Flex>
                  </Button>
                );
              })}
            </Grid>

            {/* CAR */}
            {category === 0 && (
              <>
                <Box
                  position="relative"
                  borderRadius="18px"
                  border="1px solid rgba(195,68,255,0.15)"
                  bg="linear-gradient(135deg, rgba(195,68,255,0.07), rgba(67,247,255,0.035))"
                  overflow="hidden"
                  py="20px"
                  px="8px"
                >
                  <Box
                    position="absolute"
                    top="-60px"
                    left="50%"
                    transform="translateX(-50%)"
                    w="180px"
                    h="120px"
                    bg="rgba(195,68,255,0.12)"
                    filter="blur(55px)"
                    pointerEvents="none"
                  />

                  <Grid
                    alignItems="center"
                    templateColumns="48px 1fr 48px"
                    gap="5px"
                  >
                    <Button
                      disabled={
                        currentIndexCar === 0
                      }
                      onClick={handlePrevCar}
                      variant="ghost"
                      w="44px"
                      h="52px"
                      minW="44px"
                      borderRadius="13px"
                      bg="rgba(255,255,255,0.025)"
                      border="1px solid rgba(255,255,255,0.055)"
                      _hover={{
                        bg:
                          'rgba(195,68,255,0.1)',
                      }}
                    >
                      <BiSolidLeftArrow
                        size={20}
                        color="#C344FF"
                      />
                    </Button>

                    <Flex
                      direction="column"
                      align="center"
                      textAlign="center"
                    >
                      <Flex
                        align="center"
                        justify="center"
                        w="96px"
                        h="96px"
                        mb="8px"
                        borderRadius="22px"
                        bg="rgba(255,255,255,0.025)"
                        border="1px solid rgba(255,255,255,0.06)"
                        boxShadow="
                          inset 0 0 22px rgba(195,68,255,0.04),
                          0 0 22px rgba(195,68,255,0.05)
                        "
                        color="#C344FF"
                        fontSize="78px"
                      >
                        {currentCar?.icon &&
                          React.createElement(
                            currentCar.icon
                          )}
                      </Flex>

                      <Text
                        fontSize="17px"
                        fontWeight="900"
                        color="#F7F9FC"
                      >
                        {currentCar?.name}
                      </Text>

                      <Text
                        mt="3px"
                        fontSize="10px"
                        color="rgba(255,255,255,0.32)"
                        fontWeight="700"
                      >
                        {currentIndexCar + 1} /{' '}
                        {cars.length}
                      </Text>
                    </Flex>

                    <Button
                      disabled={
                        currentIndexCar + 1 ===
                        cars.length
                      }
                      onClick={handleNextCar}
                      variant="ghost"
                      w="44px"
                      h="52px"
                      minW="44px"
                      borderRadius="13px"
                      bg="rgba(255,255,255,0.025)"
                      border="1px solid rgba(255,255,255,0.055)"
                      _hover={{
                        bg:
                          'rgba(195,68,255,0.1)',
                      }}
                    >
                      <BiSolidRightArrow
                        size={20}
                        color="#C344FF"
                      />
                    </Button>
                  </Grid>
                </Box>

                {isCarLocked && (
                  <LockedBuyCard
                    price={currentCar?.price}
                    color="#C344FF"
                    onClick={
                      AttentionSaleOnOpen
                    }
                  />
                )}

                <AttentionSaleModal
                  isOpen={AttentionSaleIsOpen}
                  onOpen={AttentionSaleOnOpen}
                  onClose={AttentionSaleOnClose}
                  tokens={tokens}
                  price={currentCar?.price}
                  handleBuy={() =>
                    handleBuy('car')
                  }
                  type="car"
                />
              </>
            )}

            {/* COLORS */}
            {category === 1 && (
              <>
                <Box
                  borderRadius="18px"
                  px="14px"
                  py="16px"
                  bg="rgba(255,255,255,0.02)"
                  border="1px solid rgba(255,255,255,0.06)"
                >
                  <Flex
                    justify="space-between"
                    align="center"
                    mb="15px"
                  >
                    <Box>
                      <Text
                        fontSize="13px"
                        fontWeight="900"
                        color="#F5F7FA"
                      >
                        Paint color
                      </Text>

                      <Text
                        mt="2px"
                        fontSize="9px"
                        color="rgba(255,255,255,0.3)"
                        textTransform="uppercase"
                        letterSpacing="0.6px"
                      >
                        Select your finish
                      </Text>
                    </Box>

                    <Text
                      fontSize="10px"
                      fontWeight="800"
                      color="#39F56B"
                    >
                      {currentIndexColors + 1} /{' '}
                      {colors.length}
                    </Text>
                  </Flex>

                  <Flex
                    wrap="wrap"
                    justify="center"
                    gap="12px"
                  >
                    {colors.map(
                      (item, index) => {
                        const selected =
                          index ===
                          activeColors;

                        const locked =
                          item.price > 0 &&
                          localStorage.getItem(
                            `myColor${index}`
                          ) !== 'true';

                        return (
                          <Box
                            key={index}
                            position="relative"
                          >
                            <Box
                              w="46px"
                              h="46px"
                              borderRadius="13px"
                              bg={item.color}
                              cursor="pointer"
                              transform={
                                selected
                                  ? 'scale(1.08)'
                                  : 'scale(1)'
                              }
                              border={
                                selected
                                  ? '3px solid #39F56B'
                                  : '2px solid rgba(255,255,255,0.08)'
                              }
                              boxShadow={
                                selected
                                  ? `0 0 16px ${item.color}55`
                                  : 'none'
                              }
                              transition="0.15s ease"
                              onClick={() => {
                                setActiveColors(
                                  index
                                );
                                setCurrentIndexColors(
                                  index
                                );
                              }}
                            />

                            {locked && (
                              <Flex
                                pointerEvents="none"
                                position="absolute"
                                inset="0"
                                align="center"
                                justify="center"
                                borderRadius="13px"
                                bg="rgba(0,0,0,0.35)"
                              >
                                <FaLock
                                  size={12}
                                  color="#fff"
                                />
                              </Flex>
                            )}
                          </Box>
                        );
                      }
                    )}
                  </Flex>
                </Box>

                {isColorLocked && (
                  <LockedBuyCard
                    price={currentColor?.price}
                    color="#39F56B"
                    onClick={
                      AttentionSaleOnOpen
                    }
                  />
                )}

                <AttentionSaleModal
                  isOpen={AttentionSaleIsOpen}
                  onOpen={AttentionSaleOnOpen}
                  onClose={AttentionSaleOnClose}
                  tokens={tokens}
                  price={currentColor?.price}
                  handleBuy={() =>
                    handleBuy('color')
                  }
                  type="color"
                />
              </>
            )}

            {/* CONTROLS */}
            {category === 2 && (
              <>
                <Box
                  position="relative"
                  borderRadius="18px"
                  border="1px solid rgba(67,247,255,0.15)"
                  bg="linear-gradient(135deg, rgba(67,247,255,0.055), rgba(195,68,255,0.035))"
                  overflow="hidden"
                  py="22px"
                  px="8px"
                >
                  <Grid
                    alignItems="center"
                    templateColumns="48px 1fr 48px"
                    gap="5px"
                  >
                    <Button
                      disabled={
                        currentIndexPedals === 0
                      }
                      onClick={
                        handlePrevPedals
                      }
                      variant="ghost"
                      w="44px"
                      h="52px"
                      minW="44px"
                      borderRadius="13px"
                      bg="rgba(255,255,255,0.025)"
                      border="1px solid rgba(255,255,255,0.055)"
                    >
                      <BiSolidLeftArrow
                        size={20}
                        color="#43F7FF"
                      />
                    </Button>

                    <Box textAlign="center">
                      <Flex
                        mx="auto"
                        mb="11px"
                        align="center"
                        justify="center"
                        w="72px"
                        h="72px"
                        borderRadius="20px"
                        bg="rgba(67,247,255,0.05)"
                        border="1px solid rgba(67,247,255,0.14)"
                        color="#43F7FF"
                        boxShadow="0 0 18px rgba(67,247,255,0.06)"
                      >
                        <FaArrowsLeftRight
                          size={28}
                        />
                      </Flex>

                      <Text
                        fontSize="16px"
                        fontWeight="900"
                        color="#F5F8FA"
                      >
                        {currentPedal?.name}
                      </Text>

                      <Text
                        mt="3px"
                        fontSize="10px"
                        fontWeight="700"
                        color="rgba(255,255,255,0.32)"
                      >
                        {currentIndexPedals + 1} /{' '}
                        {pedals.length}
                      </Text>
                    </Box>

                    <Button
                      disabled={
                        currentIndexPedals + 1 ===
                        pedals.length
                      }
                      onClick={
                        handleNextPedals
                      }
                      variant="ghost"
                      w="44px"
                      h="52px"
                      minW="44px"
                      borderRadius="13px"
                      bg="rgba(255,255,255,0.025)"
                      border="1px solid rgba(255,255,255,0.055)"
                    >
                      <BiSolidRightArrow
                        size={20}
                        color="#43F7FF"
                      />
                    </Button>
                  </Grid>
                </Box>

                {isPedalLocked && (
                  <LockedBuyCard
                    price={currentPedal?.price}
                    color="#43F7FF"
                    onClick={
                      AttentionSaleOnOpen
                    }
                  />
                )}

                <AttentionSaleModal
                  isOpen={AttentionSaleIsOpen}
                  onOpen={AttentionSaleOnOpen}
                  onClose={AttentionSaleOnClose}
                  tokens={tokens}
                  price={currentPedal?.price}
                  handleBuy={() =>
                    handleBuy('pedal')
                  }
                  type="control"
                />
              </>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

const LockedBuyCard = ({
  price,
  color,
  onClick,
}) => {
  return (
    <Flex
      mt="12px"
      px="13px"
      py="11px"
      align="center"
      justify="space-between"
      gap="12px"
      borderRadius="15px"
      bg="rgba(255,255,255,0.025)"
      border="1px solid rgba(255,255,255,0.06)"
    >
      <Flex
        align="center"
        gap="9px"
      >
        <Flex
          align="center"
          justify="center"
          w="34px"
          h="34px"
          borderRadius="10px"
          bg={`${color}12`}
          border={`1px solid ${color}30`}
        >
          <FaLock
            size={13}
            color={color}
          />
        </Flex>

        <Box>
          <Text
            fontSize="11px"
            fontWeight="900"
            color="#F3F6F9"
          >
            Locked
          </Text>

          <Text
            mt="1px"
            fontSize="9px"
            color="rgba(255,255,255,0.3)"
          >
            Unlock this item
          </Text>
        </Box>
      </Flex>

      <Button
        onClick={onClick}
        h="36px"
        minW="90px"
        borderRadius="11px"
        bg={`${color}16`}
        border={`1px solid ${color}50`}
        color={color}
        _hover={{
          bg: `${color}25`,
        }}
      >
        <Flex
          align="center"
          gap="5px"
        >
          <MdToken size={17} />

          <Text
            fontSize="13px"
            fontWeight="900"
          >
            {price}
          </Text>
        </Flex>
      </Button>
    </Flex>
  );
};

export default GarageModal;